export default __webpack_public_path__ + "static/media/Darkfury Slippers.4d47f011.jpg";